export const formatObjectValue = (value: any) => {
  return typeof value === "object" && value !== null
    ? value.name || value.id || JSON.stringify(value)
    : value;
};
